// Module
var code = "<template> <div dt-grid-row> <dt-select dt-grid-col=\"s:4\" options.bind=\"prefillSources\" id-field-name=\"id\" description-field-name=\"name\" value.bind=\"selectedPrefillSource\" label=\"Kilde til forhåndsutfylte verdier\"></dt-select> </div> </template> ";
// Exports
export default code;